const route = {
	path: 'new-cost-centers',
	name: 'center-of-cost',
	meta: {
		title: 'Centro de Costos',
	},
	component: () => import('@/pages/new-cost-centers/page-cost-center'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/new-cost-center.js